import StartSection, { BgImagesStartSection } from './StartSection';

export { BgImagesStartSection };
export default StartSection;
